import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { OrgUserOption } from '@/types';

interface CreateMatterProps {
  name: string;
  description: string;
  users: OrgUserOption[];
  code: string;
  tokenLimit?: number | null;
}

const useCreateMatter = (onSuccess: () => void) => {
  const { getFetchConfig } = useGetFetchConfig();
  const createMatter = async ({ name, description, users, code, tokenLimit }: CreateMatterProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        name,
        description,
        code,
        userIds: users.map((x) => x.id),
        ...(tokenLimit !== undefined && tokenLimit !== null ? { tokenLimit } : {}),
      },
    });

    const response = await fetch(`${APIBaseChronos}/api/matters`, fetchConfig);
    if (!response.ok) {
      throw new Error('Error creating matter');
    }
    return response.json();
  };

  return useMutation({
    onSuccess,
    onError: (error) => {
      console.error('Error creating matter:', error);
      toast.error('Error creating matter');
    },
    mutationFn: createMatter,
  });
};

export default useCreateMatter;
